module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1027-31fba43fe2d3bac95ced969471dd9b69.png";